<template>
  <div class="electronicfence-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('md')" :inline="true">
          <el-form-item :label="$t('operate.name102')" prop="fenceId">
            <el-input v-model="queryInfo.fenceId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('operate.name86')" prop="fenceName">
            <el-input v-model="queryInfo.fenceName" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('operate.name103')" prop="fenceName">
            <el-input v-model="queryInfo.fenceName" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('operate.name104')"  prop="fenceType">
            <el-select v-model="queryInfo.paymentPlatform" :placeholder="$t('public.name1')" style="width:100%">
              <el-option
              v-for="item in paymentPlatformOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item :label="$t('operate.name90')" prop="searchTime">
          <el-date-picker
            style="width:400px"
            v-model="queryInfo.searchTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
            @change="syncSearchTimeRange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div class="bt-layout">
        <el-button type="primary" size="medium" @click="getDataList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
      </div>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('operate.name105')" prop="column1" sortable></el-table-column>
      <el-table-column :label="$t('operate.name91')" prop="column2" sortable> </el-table-column>
      <el-table-column :label="$t('operate.name106')" prop="column3" sortable></el-table-column>
      <el-table-column :label="$t('operate.name107')" prop="column4" sortable></el-table-column>
      <el-table-column :label="$t('operate.name108')" prop="column5" sortable>
        <template slot-scope="scope">
          {{ scope.row.column5 | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name109')" prop="column6" sortable></el-table-column>
      <el-table-column :label="$t('operate.name110')" prop="column7" sortable></el-table-column>
      <el-table-column :label="$t('operate.name9')" width="180px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="showDetailsDialog(scope.row)">{{ $t('operate.name111') }}</el-button>
          <el-button type="text" @click="showExamine(scope.row)" v-if="scope.row.status === 2">{{ $t('operate.name112') }}</el-button>
          <el-button type="text" @click="showExamine(scope.row)" v-if="scope.row.status === 1">{{ $t('operate.name113') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <AppDialog size="md" :title="$t('operate.name122')" :visible.sync="detailsDialog" v-if="detailsDialog" :before-close="close">
      <el-row class="row-style1">
        <el-col :span="4" class="col-style margin10">
          {{ $t('operate.name105') }}
        </el-col>
        <el-col :span="10" class="col-style margin10">
          {{ $t('operate.name106') }}
        </el-col>
        <el-col :span="10" class="margin10">
          {{ $t('operate.name91') }}
        </el-col>
      </el-row>
      <el-row class="row-style2">
        <el-col :span="4" class="col-style margin10">
          {{ detailsData.column1 }}
        </el-col>
        <el-col :span="10" class="col-style margin10">
          {{ detailsData.column3 }}
        </el-col>
        <el-col :span="10" class="margin10">
          {{ detailsData.column2 }}
        </el-col>
      </el-row>
      <el-row class="row-style1">
        <el-col :span="4" class="col-style margin10">
          {{ $t('operate.name107') }}
        </el-col>
        <el-col :span="20" class="margin10">
          {{ $t('operate.name108') }}
        </el-col>
      </el-row>
      <el-row class="row-style2">
        <el-col :span="4" class="col-style margin10">
          {{ detailsData.column4 }}
        </el-col>
        <el-col :span="20" class="margin10">
          {{ detailsData.column5 }}
        </el-col>
      </el-row>
      <el-row class="row-style1">
        <el-col :span="24" class="margin10">
          {{ $t('operate.name114') }}
        </el-col>
      </el-row>
      <el-row class="row-style2">
        <el-col :span="24" class="margin10">
          {{ detailsData.reason }}
        </el-col>
      </el-row>
      <el-row class="row-style1">
        <el-col :span="24" class="margin10">
          {{ $t('operate.name123') }}
        </el-col>
      </el-row>
      <el-row class="row-style4">
        <el-col :span="24" class="margin10">
          <el-collapse v-model="activeNames" @change="handleChange">
  <el-collapse-item :title="$t('operate.name115') + detailsData.auditNum + ' ' + $t('operate.name116') + detailsData.applyTime" name="1">
    <div>{{ $t('operate.name117') }}{{ detailsData.auditID }}</div>
    <div>{{ $t('operate.name118') }}{{ detailsData.auditTime }}</div>
    <div>{{ $t('operate.name119') }}{{ detailsData.auditReason }}</div>
    <div>{{ $t('operate.name120') }}{{ detailsData.auditResult }}</div>
  </el-collapse-item>
</el-collapse>
        </el-col>
      </el-row>
      <el-row class="row-style1">
        <el-col :span="24" class="margin10">
          {{ $t('operate.name121') }}
        </el-col>
      </el-row>
      <el-row class="row-style3">
        <el-col :span="24" class="margin10">
        </el-col>
      </el-row>
    </AppDialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AppDialog from '@/components/AppDialog/index.vue'

/** 演示页：暂无后端 API，本地 mock 数据 + 账号时区时间筛选；接入 API 后替换 getDataList */
const MOCK_REFUND_RECORDS = [
  {
    column1: '1005',
    column2: 'f3c4fc6aba53420d9531045ad55d5590',
    column3: '2ba0f459950743f9b587f037cc82c6f0',
    column4: '0.01',
    column5: '2023-03-24 09:44:30',
    column6: '已审核',
    column7: '',
    status: 2,
    reason: 'aaaaa',
    auditNum: 'f74e9fe7b02b7ef2e02d81654c69a9fa',
    applyTime: '2023-03-13 09:35:25',
    auditID: '1001',
    auditTime: '2023-03-30 17:45:31',
    auditReason: '123',
    auditResult: '审核通过'
  },
  {
    column1: '1004',
    column2: 'f58baa92affa464791f1e9bf65eab5cc',
    column3: '2ba0f459950743f9b587f037cc82c6f0',
    column4: '1',
    column5: '2023-03-24 09:44:03',
    column6: '未审核',
    column7: '',
    status: 1,
    reason: 'bbbbbb',
    auditNum: '',
    applyTime: '',
    auditID: '',
    auditTime: '',
    auditReason: '',
    auditResult: ''
  },
  {
    column1: '80cb4dd54dc6472dbeeef17dbe5ce397',
    column2: '20230307',
    column3: '2ba0f459950743f9b587f037cc82c6f0',
    column4: '1',
    column5: '2023-08-24 09:44:03',
    column6: '已复核',
    column7: '审核通过',
    status: 3,
    reason: 'cccccc',
    auditNum: 'f74e9fe7b02b7ef2e02d81654c69a9fa',
    applyTime: '2023-03-13 09:35:25',
    auditID: '1001',
    auditTime: '2023-03-30 17:45:31',
    auditReason: '123',
    auditResult: '审核不通过'
  }
]

export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      queryInfo: {
        fenceId: '',
        fenceName: '',
        fenceType: '',
        pageSize: 10,
        pageNumber: 1,
        paymentPlatform: '',
        searchTime: [],
        startTime: '',
        endTime: ''
      },
      tableLoading: false,
      total: 0,
      allMockData: MOCK_REFUND_RECORDS,
      cachedList: [],
      tableList: [],
      paymentPlatformOptions: [
        { label: '审核失败', value: 1 },
        { label: '审核成功', value: 2 }
      ],
      detailsData: {},
      fenceInfoRules: {
        area: [
          {
            required: true,
            message: this.$t('operate.name171'),
            trigger: 'blur'
          }
        ],
        fenceName: [
          {
            required: true,
            message: this.$t('operate.name172'),
            trigger: 'blur'
          }
        ],
        fenceType: [
          {
            required: true,
            message: this.$t('operate.name173'),
            trigger: 'blur'
          }
        ],
        draw: [
          {
            required: true,
            message: this.$t('operate.name174'),
            trigger: 'blur'
          }
        ]
      },
      detailsDialog: false
    }
  },
  components: { AppDialog },
  created() {
    this.getDataList()
  },
  mounted() {
  },
  methods: {
    applyAccountTimeQuery() {
      if (this.queryInfo.searchTime && this.queryInfo.searchTime.length === 2) {
        const { startTime, endTime } = this.$tz.rangeToAccountQuery(this.queryInfo.searchTime)
        this.queryInfo.startTime = startTime
        this.queryInfo.endTime = endTime
      } else {
        this.queryInfo.startTime = ''
        this.queryInfo.endTime = ''
      }
    },
    syncSearchTimeRange (val) {
      const { startTime, endTime } = this.$tz.rangeToAccountQuery(val)
      this.queryInfo.startTime = startTime
      this.queryInfo.endTime = endTime
    },
    filterMockRecords(records) {
      let list = records
      if (this.queryInfo.paymentPlatform) {
        list = list.filter((row) => row.status === this.queryInfo.paymentPlatform)
      }
      if (this.queryInfo.startTime && this.queryInfo.endTime) {
        list = list.filter((row) => {
          const t = row.column5
          return t && t >= this.queryInfo.startTime && t <= this.queryInfo.endTime
        })
      }
      return list
    },
    paginate(list) {
      this.total = list.length
      const start = (this.queryInfo.pageNumber - 1) * this.queryInfo.pageSize
      this.tableList = list.slice(start, start + this.queryInfo.pageSize)
    },
    getDataList() {
      this.queryInfo.pageNumber = 1
      this.applyAccountTimeQuery()
      this.tableLoading = true
      this.cachedList = this.filterMockRecords(this.allMockData)
      this.paginate(this.cachedList)
      this.tableLoading = false
    },
    resetQuery() {
      this.queryInfo = {
        fenceId: '',
        fenceName: '',
        fenceType: '',
        pageSize: 10,
        pageNumber: 1,
        paymentPlatform: '',
        searchTime: [],
        startTime: '',
        endTime: ''
      }
      this.getDataList()
    },
    showDetailsDialog(row) {
      this.detailsData = row
      this.detailsDialog = true
    },
    showExamine(row) {
      var tip = ''
      var message = ''
      if (row.status === 1) {
        tip = this.$t('operate.name125')
        message = this.$t('operate.name113')
      } else {
        tip = this.$t('operate.name124')
        message = this.$t('operate.name112')
      }
      this.$confirm(tip, this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      }).then(() => {}).catch(() => {
        this.$message({
          type: 'info',
          message: message
        })
      })
    },
    // 改每页条数时回到第一页，避免本地 slice 出现空页
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.queryInfo.pageNumber = 1
      this.paginate(this.cachedList)
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.paginate(this.cachedList)
    }
  }
}
</script>
<style lang="scss">
.el-collapse {
  border-top: 0px solid #EBEEF5 !important;
  border-bottom: 0px solid #EBEEF5 !important;
}
</style>
<style lang="scss" scoped>
.electronicfence-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .bt-layout {
    display: flex;
    flex-direction: row;
    height: 36px;
  }
  .margin10 {
    padding-left: 10px;
  }
  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }
  .row-style1 {
    border: 1px solid #dcdddd;
    border-bottom: none;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    background: #f5f5f5;
  }
  .row-style2 {
    border: 1px solid #dcdddd;
    border-bottom: none;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  .row-style4 {
    border: 1px solid #dcdddd;
    border-bottom: none;
    height: auto;
    width: 100%;
    display: flex;
    align-items: center;
  }

  .row-style3 {
    border: 1px solid #dcdddd;
    height: 100px;
    width: 100%;
    display: flex;
    align-items: center;
  }
  .col-style {
    border-right: 1px solid #dcdddd;
    height: 40px;
    display: flex;
    align-items: center;
  }
  .margin10 {
    padding-left: 10px;
  }
}
</style>
